import { InjectionToken } from '@angular/core';

/**
 * Abstract z-index service interface.
 * Consumers can provide their own implementation (e.g. PrimeNG-backed)
 * via the BS_ZINDEX_SERVICE injection token.
 */
export interface BsZIndexService {
  set(key: string, el: HTMLElement, baseZIndex: number): void;
  clear(el: HTMLElement): void;
  getCurrent(): number;
}

/**
 * Default z-index service implementation.
 * Simple counter-based approach that works without any framework dependency.
 */
export class DefaultBsZIndexService implements BsZIndexService {
  private zIndexes: { key: string; value: number }[] = [];

  set(key: string, el: HTMLElement, baseZIndex: number): void {
    const last = this.zIndexes.length > 0
      ? this.zIndexes[this.zIndexes.length - 1]
      : { key, value: baseZIndex };
    const newZIndex = last.value + (last.key === key ? 0 : baseZIndex) + 2;
    this.zIndexes.push({ key, value: newZIndex });
    el.style.zIndex = String(newZIndex);
  }

  clear(el: HTMLElement): void {
    const zIndex = parseInt(el.style.zIndex, 10) || 0;
    this.zIndexes = this.zIndexes.filter((obj) => obj.value !== zIndex);
    el.style.zIndex = '';
  }

  getCurrent(): number {
    return this.zIndexes.length > 0
      ? this.zIndexes[this.zIndexes.length - 1].value
      : 0;
  }
}

export const BS_ZINDEX_SERVICE = new InjectionToken<BsZIndexService>(
  'BsZIndexService',
  {
    providedIn: 'root',
    factory: () => new DefaultBsZIndexService(),
  }
);
